import jQuery from 'jquery';

export const initUpload = () => {
    jQuery(() => {
        const $upload = jQuery('input[type="file"]');

        if ($upload.length) {
            $upload.each(function () {
                jQuery(this).wrap('<div class="upload-file"></div>');
                const $placeholder = jQuery(this).attr('name');
                const res = $placeholder.replace('-', ' ');
                jQuery(`<span>${res}</span>`).insertAfter(this);
                jQuery(this).change(function () {
                    const vl = jQuery(this).val();
                    const file = vl.split('\\').pop();
                    jQuery(this).next('span').text(file);
                });
            });
        }
    });
};
